import Vue from 'vue'

export default () => {
  if (window.GenCert !== undefined) {
    const avalaraGenCert = window.GenCert
    Vue.prototype.$avalaraGenCert = avalaraGenCert
  }
}
